<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'coreuiStore/updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>
      <img class="sidebar-brand-full" :src="imgLogo" />
      <CAvatar :src="avatar" size="xl" class="sidebar-brand-narrow" />
      <!-- <CSidebarBrand style="background: #f0f8ff00">
        <CIcon :icon="iconFlag" size="3xl" class="sidebar-brand-full" />
        <CIcon :icon="iconFlag" size="xxl" class="sidebar-brand-narrow" />
      </CSidebarBrand> -->
    </CSidebarBrand>
    <AppSidebarNav />
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('coreuiStore/toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import imgLogo from '@/assets/images/loginImgs/logo.png'
import avatar from '@/assets/images/avatars/avatarTransparent.png'
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    const iconFlag = process.env.VUE_APP_ICON_FLAG
    return {
      imgLogo,
      iconFlag,
      avatar,
      sidebarUnfoldable: computed(
        () => store.state.coreuiStore.sidebarUnfoldable,
      ),
      sidebarVisible: computed(() => store.state.coreuiStore.sidebarVisible),
    }
  },
}
</script>
